module.exports = __webpack_public_path__ + "img/AUDI.9efdc5be.webp";